<script lang="ts">
import Navigation from "@/Components/Generics/Navigation.vue";
import NavigationLink from "@/Components/NavigationLink.vue";
import { NavigationLinkType } from "@/Types/navigation";
import { defineComponent } from "vue";

export default defineComponent({
    name: "MainNavigation",
    components: { Navigation, NavigationLink },
    computed: {
        routes(): Array<NavigationLinkType> {
            return [
                {
                    hrefRoute: "main",
                    pageRoute: "/",
                    title: this.$trans("navigation.nav_find"),
                },
                {
                    hrefRoute: "search.index",
                    pageRoute: "/search",
                    title: this.$trans("navigation.nav_search"),
                },
                {
                    hrefRoute: "economic-sectors",
                    pageRoute: "/economic-sectors",
                    title: this.$trans("navigation.nav_economic_sectors"),
                },
                {
                    hrefRoute: "qualifications",
                    pageRoute: "/qualifications",
                    title: this.$trans("navigation.nav_qualifications"),
                },
                {
                    hrefRoute: "events",
                    pageRoute: "/events",
                    title: this.$trans("navigation.nav_events"),
                },
                // {
                //     href: "mailto:contact@deinjobfuchs.de",
                //     title: this.$trans("navigation.nav_contact"),
                //     notALink: true,
                // },
            ];
        },
    },
});
</script>

<template>
    <Navigation :show-login="true">
        <NavigationLink v-for="route in routes" :key="route.title" :href-route="route.hrefRoute" :href="route.href" :page-route="route.pageRoute" :title="route.title" :not-a-link="route.notALink" />
    </Navigation>
</template>
